import { render, staticRenderFns } from "./SettingsTableRow.vue?vue&type=template&id=1ecbf08e&scoped=true"
import script from "./SettingsTableRow.vue?vue&type=script&lang=ts"
export * from "./SettingsTableRow.vue?vue&type=script&lang=ts"
import style0 from "./SettingsTableRow.vue?vue&type=style&index=0&id=1ecbf08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecbf08e",
  null
  
)

export default component.exports